module.exports = __webpack_public_path__ + "static/media/b-sci-major-18_LR.0a5d6db7.jpg";